import React from 'react';
import { TYPES, TYPE_LABELS, TYPE_IMG } from '../../lib/driveMedia';

export const AppHeader = ({ logo, type = TYPE_IMG, counts = {}, onTypeSwitchClick }) => {
  const available = TYPES.filter(item => counts[item]);

  return (
    <header className="app-header">
      {logo && <img className="app-header-logo" src={logo} alt="Gallery logo" />}
      {available.length > 1 && (
        <nav className="type-switch" aria-label="Media type">
          {available.map(item => (
            <button
              key={item}
              type="button"
              disabled={item === type}
              aria-pressed={item === type}
              onClick={() => onTypeSwitchClick(item)}
            >
              {TYPE_LABELS[item]}
              <span className="type-switch-count">{counts[item]}</span>
            </button>
          ))}
        </nav>
      )}
    </header>
  );
};
